import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConfigurationFacade } from '../facades/configuration.facade';
import { I18nService } from '../services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SapGuard implements CanActivate {
  private readonly router: Router = inject(Router);
  private readonly i18nService: I18nService = inject(I18nService);
  private readonly configurationFacade: ConfigurationFacade = inject(ConfigurationFacade);

  canActivate(): Observable<boolean> {
    return this.configurationFacade.getSapStatus().pipe(
      map(({ sapIntegration, sapIntegrationRequired }: { sapIntegration: boolean; sapIntegrationRequired: boolean }) => {
        if (!sapIntegration && sapIntegrationRequired) {
          this.router.navigate([this.i18nService.getCurrentLocale()]).then();
          return false;
        }
        return true;
      })
    );
  }
}
